import { createSlice } from '@reduxjs/toolkit'

const routeValue = sessionStorage.getItem('currentRoute')

export const routeSlice = createSlice({
  name: 'route',
  initialState: routeValue || "Overview",
  reducers: {
    currentRoute: (state, action) =>{
        sessionStorage.setItem('currentRoute', action.payload)
        return action.payload
    },
  },
})

export const { currentRoute } = routeSlice.actions

export default routeSlice.reducer